import { ITaskSession, tAnswer } from 'common/modules/ReactShared';
import { useCallback } from 'react';

type tLearnTaskActionsArgs = {
  lessonTaskSession: ITaskSession | null;
  isCompleting: boolean;
  onFinishAndNext(answers?: tAnswer): Promise<void>;
};

type tLearnTaskActions = {
  onFinish: () => void;
};

const useLearnTaskActions = (args: tLearnTaskActionsArgs): tLearnTaskActions => {
  const { isCompleting, onFinishAndNext, lessonTaskSession } = args;

  const onFinish = useCallback(() => {
    if (!isCompleting) {
      onFinishAndNext(
        lessonTaskSession?.taskItemSessions.map((item) => ({
          ...item,
          completed: true
        }))
      );
    }
  }, [onFinishAndNext, lessonTaskSession, isCompleting]);

  return {
    onFinish
  };
};

export { useLearnTaskActions };
export type { tLearnTaskActions, tLearnTaskActionsArgs };
